export class NotificationDTO {
    id: number;
    title: string;
    body: string;
    readed: boolean;
    data?: any;
    time: Date;
}
